import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle, FormControl
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
// import { FormControl } from "@mui/material";
// import {
// 	MuiPickersUtilsProvider,
// 	DatePicker
// } from "@mui/material/pickers";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import {
	resetGetTransactionTypeList,
	getTransactionTypeListDetails
} from "../../redux/actions/getTransactionTypeListAction";
import Autocomplete from "@mui/lab/Autocomplete";
import moment from "moment";
import {
	resetGetFeeReportList,
	getFeeReportList
} from "../../redux/actions/getFeeReportListAction";
import {
	resetGetFeeReportFile,
	getFeeReportFile
} from "../../redux/actions/getFeeReportFileAction";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import SearchIcon from "@mui/icons-material/Search";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import { FileExcelFilled, FilePdfFilled } from "@ant-design/icons";
import Util from "../../validation";
// import Excel from "../../assets/img/excel.png";
// import PDF from "../../assets/img/pdf1.png";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getCustomerIdAndNameList } from "../../redux/actions/getCustomerIdAndNameListAction";
import { getRegenerateToken } from "../../redux/actions/regenerateTokenAction";
import { getTransactionCurrencyListAction } from "../../redux/actions/getTransactionCurrencyList";
import { partnerTransactionSubTypesListReq } from "../../redux/actions/transactionSubTypesPartnerAction";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const FeeReport = () => {
	const Theme = useSelector((state) => state.theme.theme);

	const csv = "1";
	const pdf = "0";
	var date = new Date();
	const [customerId, setCustomerId] = useState("");
	const [transactionType, setTransactionType] = useState("");
	const [currency, setCurrency] = useState("");
	const [transactionSubType, setTransactionSubType] = useState("");
	const [getFeeReportListStatus, setgetFeeReportListStatus] = useState(false);
	const [getFeeReportFileResStatus, setgetFeeReportFileResStatus] =
		useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const [rowsPerPage, setRowsPerPage] = useState(5);

	const [page, setPage] = useState(0);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		const newRowsPerPage = parseInt(event.target.value, 10);
		const currentFirstRowIndex = page * rowsPerPage;
		const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);

		setRowsPerPage(newRowsPerPage);
		setPage(newPage);
	};

	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);

	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState([]);

	const [transactionSubTypesLists, getSetTransactionTypesLists] = useState(false)

	const handleDateChange = (date) => {
		setSelectedDate(date);
		if (date > selectedToDate) {
			setSelectedToDate(date)
		}
	};
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const classes = useStyles();
	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const handleChange = ({ target: { name, value } }) => {
		// if (name === "customerId") {
		// 	// setCustomerId(value);
		// 	Util.verifyNumber(value)
		// 		? setCustomerId(value)
		// 		: setCustomerId(customerId);
		// }
		if (name === "customerId") {
			// console.log("CustIDDDD", customerId)
			setCustomerId(value)
		}
		if (name === "transactionType") {
			const selectedValue = value === "All" ? "" : value;
			// setTransactionType(value);
			// setTransactionType(value == "All" ? "" : value);
			setTransactionType(selectedValue);
		}
		if (name === "currency") {
			// setCurrency(value);
			setCurrency(value == "Select Currency" ? "" : value);
		}
		if (name === "transactionSubType") {
			// setTransactionSubType(value);
			setTransactionSubType(value == "All" ? "" : value);
		}
	};

	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getFeeReportListRes = useSelector(
		({ getFeeReportList }) => getFeeReportList
	);

	// const getFeeReportFileRes = useSelector(
	// 	({ getFeeReportFile }) => getFeeReportFile
	// );

	const generateFeeReportFileRes = useSelector(
		({getFeeReportFile}) => getFeeReportFile
	);

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);

	const getTransactionCurrencyListRes = useSelector(
		({ getTransactionCurrencyList }) => getTransactionCurrencyList
	);

	const getTransactionSubTypesRes = useSelector(
		({ partnerTransactionSubTypesLists }) => partnerTransactionSubTypesLists
	);

	const getTransactionSubTypeListReqApi = () => {
		getSetTransactionTypesLists(true);
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
				transactionType: transactionType
			}
		};
		return dispatch(partnerTransactionSubTypesListReq(req, authToken));
	};

	// Trigger when transactionType changes
	useEffect(() => {
		if (transactionType) {
			getTransactionSubTypeListReqApi();
		}
	}, [transactionType]);

	// Reset subtype when type changes
	useEffect(() => {
		setTransactionSubType("");
		setGetTransactionSubTypeListResArray([]);
	}, [transactionType]);

	// Handle subtype response
	useEffect(() => {
		if (transactionSubTypesLists) {
			if (getTransactionSubTypesRes.data.status === "Success") {
				setGetTransactionSubTypeListResArray(
					getTransactionSubTypesRes.data.transactionSubtype
				);
			}
			if (getTransactionSubTypesRes.data.status === "Failed" ||
				getTransactionSubTypesRes.data.status === "failed") {
				setGetTransactionSubTypeListResArray([]);
			}
		}
	}, [getTransactionSubTypesRes]);

	// Add login selector
	const login = useSelector((state) => state.login);

	const getTransactionCurrencyListFunc = () => {
		const requestData = {
			loginDetails: {
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
			},
		};
		dispatch(getTransactionCurrencyListAction(requestData, authToken));
	};


	useEffect(() => {
		getTransactionCurrencyListFunc();
	}, [regenerateTokenRes.data.status]);

	// console.log("getSummeryReportFileRes");
	// console.log(getFeeReportListRes);
	//getFeeReportList: getFeeReportListReducer,
	const [
		getTransactionSubTypeListResArray,
		setGetTransactionSubTypeListResArray
	] = useState([]);

	const getTransactionTypeList = () => {
		if (getTransactionTypeListRes.data.status == "success") {
			setGetTransactionTypeListResArray(
				getTransactionTypeListRes.data.transactionType
			);
			// setGetTransactionSubTypeListResArray(
			// 	getTransactionTypeListRes.data.transactionSubtype
			// );
		}
	};

	useEffect(() => {
		getTransactionTypeList();
	}, [getTransactionTypeListRes.data.status == "success"]);

	const getTransactionTypeListReqApi = () => {
		const getTransactionTypeListReq = {
			loginDetails: {
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
			}

		};

		return dispatch(
			getTransactionTypeListDetails(getTransactionTypeListReq, authToken)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success")
			getTransactionTypeListReqApi();
	}, [regenerateTokenRes.data.status]);

	const handleDownloadClick = (csvOrPdf) => {
		if (generateFeeReportFileRes.isLoading) return;
		getFeeReportFileExcelOrPdf(csvOrPdf);
	};

	const getFeeReportListReq = () => {
		setgetFeeReportListStatus(true);
		setIsLoading(true);
		const getTransactionTypeListReq = {
			loginDetails: {
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
			},
			walletTransactionMasterDetailsRequestVO: {
				currency: currency,
				fromDate: moment(selectedDate).format("DD/MM/YYYY"),
				toDate: moment(selectedToDate).format("DD/MM/YYYY"),
				walletCustomerId: customerId.split("-")[0] || "",
				transactionType: transactionType,
				transactionSubType: transactionSubType
			}
		};

		return dispatch(getFeeReportList(getTransactionTypeListReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getFeeReportListReq();
		}
	}, [regenerateTokenRes.data.status]);



	// const getFReportFileExcelOrPdf = (csvOrpdf) => {
	// 	setgetFeeReportFileResStatus(true);
	// 	const getFReportFileExcelOrPdfReq = {
	// 		loginDetails: {
	// 			walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
	// 		},
	// 		walletTransactionMasterDetailsRequestVO: {
	// 			currency: currency,
	// 			fromDate: moment(selectedDate).format("DD/MM/YYYY"),
	// 			toDate: moment(selectedToDate).format("DD/MM/YYYY"),
	// 			walletCustomerId: customerId,
	// 			transactionType: transactionType,
	// 			transactionSubType: transactionSubType,
	// 			reportFileType: csvOrpdf == "1" ? "csv" : "pdf"
	// 		}
	// 	};

	// 	return dispatch(getFeeReportFile(getFReportFileExcelOrPdfReq, authToken));
	// };

	const getFeeReportFileExcelOrPdf = (csvOrPdf) => {
		const fileType = csvOrPdf === "1" ? "csv" : "pdf";

		const requestObj = {
			loginDetails: {
				walletOwnerId:
					login.data.subRole === ""
						? login.data.partnerId
						: login.data.parentId,
			},
			walletTransactionMasterDetailsRequestVO: {
				currency: currency,
				fromDate: moment(selectedDate).format("DD/MM/YYYY"),
				toDate: moment(selectedToDate).format("DD/MM/YYYY"),
				walletCustomerId: customerId?.split("-")[0],
				reportFileType: fileType,
				pageNo: 1,
				records: rowsPerPage,
			},
		};

		dispatch(
			getFeeReportFile(
				requestObj,
				authToken,
				fileType
			)
		);
	};

	useEffect(() => {
		if (!generateFeeReportFileRes.success) return;

		const blob = generateFeeReportFileRes.data?.blob;
		if (!blob) return;

		const url = window.URL.createObjectURL(blob);

		const link = document.createElement("a");
		link.href = url;

		let extension = "csv";
		if (blob.type.includes("zip")) extension = "zip";
		else if (blob.type.includes("pdf")) extension = "pdf";

		link.download = `FeeReport.${extension}`;

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		window.URL.revokeObjectURL(url);

		dispatch(resetGetFeeReportFile());
	}, [generateFeeReportFileRes]);



	// useEffect(() => {
	// 	if (getFeeReportFileResStatus) {
	// 		if (getFeeReportFileRes.data.status == "success") {
	// 			var link = document.createElement("a");
	// 			link.download = getFeeReportFileRes.data.fileName;
	// 			link.href =
	// 				"data:application/octet-stream;base64," +
	// 				getFeeReportFileRes.data.fileDate.split(`,`)[1];
	// 			document.body.appendChild(link);
	// 			link.click();
	// 			document.body.removeChild(link);
	// 		}
	// 	}
	// }, [getFeeReportFileRes.data.status]);

	// useEffect(() => {
	// 	if (getFeeReportFileResStatus) {
	// 		if (getFeeReportFileRes.data.status == "success") {

	// 			// ✅ Create link, append to body, click, then remove safely
	// 			const link = document.createElement("a");
	// 			link.href = getFeeReportFileRes.data.filePath;
	// 			link.download = getFeeReportFileRes.data.filePath.split("/").pop();
	// 			link.target = "_blank";

	// 			document.body.appendChild(link); // ✅ append to body first
	// 			link.click();
	// 			document.body.removeChild(link); // ✅ remove from same parent
	// 		}
	// 	}
	// }, [getFeeReportFileRes.data.status]);



	useEffect(() => {
		if (getFeeReportListStatus) {
			setIsLoading(false);
			if (getFeeReportListRes.data.status == "success") {
			}
			if (getFeeReportListRes.data.status == "failure") {
				if (
					getFeeReportListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getFeeReportListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}, [getFeeReportListRes.data.status]);

	useEffect(() => {
		if (getFeeReportListRes.data.status == "success") {
			setPage(0);
		}
	}, [getFeeReportListRes.data.status]);

	useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "Success") {
			//console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);


	const filterOptionsL = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}
	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth style={{ marginTop: "5px" }}>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM/dd/yyyy"
										value={selectedDate}
										onChange={handleDateChange}
										disableFuture={true}
									/>
								</LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth style={{ marginTop: "5px" }}>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM/dd/yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
										disableFuture={true}
										minDate={selectedDate}

									/>
								</LocalizationProvider>
							</FormControl>
						</Grid>

						{/* <Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Customer ID"
								// style={{paddingBottom:"9px"}}
								// required
								type="text"
								fullWidth
								// variant="standard"
								value={customerId || ""}
								name="customerId"
								onChange={handleChange}
							/>
						</Grid> */}
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getCustomerIdAndNameListRes.data.currencyList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptionsL}
								value={customerId}
								onChange={handleChange}
								onInputChange={(event, newInputValue) => {
									setCustomerId(newInputValue);
								}}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Customer ID"
										style={{ marginTop: "3px" }}
										// required
										type="tel"
										fullWidth
										{...params}

										name="customerId"

										variant="standard"
										sx={{
											"& .MuiInput-underline:before": {
												borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
												borderBottomColor: "gray", // White color after focus
											},
										}}
									/>
								)}
							/>
						</Grid>

						<Grid xs={12} item sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Transaction Type"
								type="name"
								fullWidth
								variant="standard"
								name="transactionType"
								// value={transactionType || ""}
								defaultValue={"All" || transactionType}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>
								{(() => {
									if (getTransactionTypeListResArray) {
										return []
											.concat(getTransactionTypeListResArray)
											.map((c) => (
												<MenuItem value={c} key={c}>
													{c}
												</MenuItem>
											));
									} else {
										return <MenuItem>No Data</MenuItem>;
									}
								})()}
							</TextField>
						</Grid>

						<Grid xs={12} item sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Transaction SubType"
								type="name"
								fullWidth
								variant="standard"
								name="transactionSubType"
								// value={transactionSubType || ""}
								defaultValue={"All" || transactionSubType}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>

								{(() => {
									if (getTransactionSubTypeListResArray) {
										return []
											.concat(getTransactionSubTypeListResArray)
											.map((c) => (
												<MenuItem value={c} key={c}>
													{c}
												</MenuItem>
											));
									} else {
										return <MenuItem>No Data</MenuItem>;
									}
								})()}
							</TextField>
						</Grid>

						<Grid xs={12} item sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Currency"
								type="name"
								fullWidth
								name="currency"
								defaultValue={"Select Currency" || currency}
								onChange={handleChange}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{/* ✅ Replace adminCurrencyList */}
								{getTransactionCurrencyListRes?.success &&
									getTransactionCurrencyListRes?.data?.status === "success" &&
									[]
										.concat(getTransactionCurrencyListRes.data.currencyList || [])
										.map((x) => <MenuItem value={x} key={x}>{x}</MenuItem>)
								}
							</TextField>
						</Grid>

						<Grid xs={12} item sm={12} md={3} lg={3}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                  marginTop: "1rem",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getFeeReportListReq}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getFeeReportListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>

					{/* <Grid
            container
            style={{
              padding: "10px",
              marginTop: "1.5rem",
              marginBottom: "15px",
            }}
          >
            <Grid item md={5}>
              <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getFeeReportListReq}
              >
                Search
              </Button>
            </Grid>
            <Grid item md={7}></Grid>
          </Grid> */}
				</Card>
				{isLoading ? (
					<LoadingSpinner />
				) : !getFeeReportListStatus ||
					getFeeReportListRes.data.transactionList == undefined ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					// <div>

					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Report Table
								</Typography>
							</Grid>
							<Grid
								container
								style={{
									padding: "10px",
									textAlign: "center",
									justifyContent: "right",
									gap: "10px"
								}}
							>
								<Grid item xs={4} sm={4} md={1} lg={1}>
									{/* <Button
                    style={{
                      backgroundColor: "#00b9f5",
                      color: "white",
                      fontSize: "10px",
                    }}
                    variant="contained"
                    onClick={() => {
                      getFReportFileExcelOrPdf(csv);
                    }}
                  >
                    <b>Export To Excel</b> &nbsp; &nbsp;
                    <FileExcelFilled
                      style={{ color: "#fff", fontSize: "16px" }}
                    />
                  </Button> */}
									{/* <img
										// src={Excel}
										src={`${process.env.PUBLIC_URL}/${Theme}/excel.png`}
										style={{ height: "30px", cursor: "pointer" }}
										onClick={() => {
											getFReportFileExcelOrPdf(csv);
										}}
									></img> */}
									 <img
										src={`${process.env.PUBLIC_URL}/${Theme}/excel.png`}
										alt="fee-report"
										style={{
											height: "30px",
											cursor: generateFeeReportFileRes.isLoading
												? "not-allowed"
												: "pointer",
											opacity: generateFeeReportFileRes.isLoading ? 0.5 : 1,
										}}
										onClick={() => handleDownloadClick("1")}
									/>
								</Grid>
								<Grid item xs={4} sm={4} md={1} lg={1}> 
									{/* <Button
                    style={{
                      backgroundColor: "#00b9f5",
                      color: "white",
                      fontSize: "10px",
                    }}
                    variant="contained"
                    onClick={() => {
                      getFReportFileExcelOrPdf(pdf);
                    }}
                  >
                    <b>Export To PDF</b> &nbsp; &nbsp;
                    <FilePdfFilled
                      style={{ color: "#fff", fontSize: "16px" }}
                    />
                  </Button> */}
									{/* <img
										// src={PDF}
										src={`${process.env.PUBLIC_URL}/${Theme}/pdf1.png`}
										style={{ height: "30px", cursor: "pointer" }}
										onClick={() => {
											getFReportFileExcelOrPdf(pdf);
										}}
									></img> */}
									 <img
										src={`${process.env.PUBLIC_URL}/${Theme}/pdf1.png`}
										alt="fee-report"
										style={{
											height: "30px",
											cursor: generateFeeReportFileRes.isLoading
												? "not-allowed"
												: "pointer",
											opacity: generateFeeReportFileRes.isLoading ? 0.5 : 1,
										}}
										onClick={() => handleDownloadClick("0")}
									/> 
								</Grid>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table className={classes.table}>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Id{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Role{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Transaction Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Transaction SubType
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												No. of Transaction
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Total Fee Received
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Total Fee Paid
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getFeeReportListRes &&
											getFeeReportListRes.data &&
											getFeeReportListRes.data.transactionList &&
											[]
												.concat(getFeeReportListRes.data.transactionList)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index + 1}>
														<TableCell align="center">{row.fromCustomerId}</TableCell>
														<TableCell align="center">{row.userRole}</TableCell>
														<TableCell align="center">
															{row.transactionType}
														</TableCell>
														<TableCell align="center">
															{row.transactionSubType}
														</TableCell>
														<TableCell align="center">{row.currency}</TableCell>
														<TableCell align="center">
															{row.noOfTransaction}
														</TableCell>
														<TableCell align="center">
															{row.creditAmount}
														</TableCell>
														<TableCell align="center">
															{row.debitAmount}
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={
										[].concat(getFeeReportListRes.data.transactionList).length
									}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>

					// </div>
				)}
			</Layout>
		</>
	);
};

export default FeeReport;
